import PackingListSummary from './packing-list-summary';

export default PackingListSummary;